import { Component, HostListener } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import emailjs, { type EmailJSResponseStatus } from '@emailjs/browser';

@Component({
  selector: 'app-home-six',
  templateUrl: './home-six.component.html',
  styleUrl: './home-six.component.css'
})
export class HomeSixComponent {
  isTransparent = true;
  isMenuOpen = false;
  activeDropdown: number | null = null;

  toggleMenu(): void {
    this.isMenuOpen = !this.isMenuOpen;
  }

  toggleDropdown(index: number): void {
    this.activeDropdown = this.activeDropdown === index ? null : index;
  }

  closeMenu(): void {
    this.isMenuOpen = false;
    this.activeDropdown = null;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    const target = event.target as HTMLElement;
    if (!target.closest('.nav-item') && !target.closest('.header-toggle')) {
      this.activeDropdown = null;
    }
  }

  @HostListener('window:scroll', [])
  onWindowScroll(): void {
    const offset = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    this.isTransparent = offset < 100;
  }

  // OWl Slider
  customOptions: OwlOptions = {
    loop: true,
    dots: true,
    margin:0,
    nav:true,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 1,
    navText: ['<i class="bi bi-arrow-left"></i>', '<i class="bi bi-arrow-right"></i>'],
  }

  slideStore = [
    {
      title: "Let's build something extraordinary together.",
      subtitle: "We Turn Ideas Into Impact",
      image: "assets/images/slides/slide-1.jpg"
    },

    {
      title: "We Don't Just Create, We Wow",
      subtitle: "Designs That Speak",
      image: "assets/images/slides/slide-2.jpg"
    },

    {
      title: "From strategy to execution, we craft results that matter",
      subtitle: "Your Creative Growth Partner",
      image: "assets/images/slides/slide-3.jpg"
    }

  ];

  //Services
  services = [
      {
        img: 'assets/images/about/about-sm-1.jpg',
        alt: 'about-1',
        title: 'Web Design',
        description: 'Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue.',
        link: '/services'
      },
      {
        img: 'assets/images/about/about-sm-2.jpg',
        alt: 'about-2',
        title: 'App Development',
        description: 'Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue.',
        link: '/services'
      },
      {
        img: 'assets/images/about/about-sm-3.jpg',
        alt: 'about-3',
        title: 'Branding',
        description: 'Phasellus viverra nulla ut metus varius laoreet. Quisque rutrum. Aenean imperdiet. Etiam ultricies nisi vel augue.',
        link: '/services'
      }
  ];

  
  // Gallery Properties
  currentGalleryIndex = 0;
  showGalleryModal = false;

  // Gallery Items
  galleryItems = [
    {
      src: 'assets/images/portfolio/gallery-14.jpg',
      title: 'Gallery Image 1'
    },
    {
      src: 'assets/images/portfolio/gallery-15.jpg',
      title: 'Gallery Image 2'
    },
    {
      src: 'assets/images/portfolio/gallery-16.jpg',
      title: 'Gallery Image 3'
    },
    {
      src: 'assets/images/portfolio/gallery-17.jpg',
      title: 'Gallery Image 4'
    },
    {
      src: 'assets/images/portfolio/gallery-18.jpg',
      title: 'Gallery Image 5'
    },
    {
      src: 'assets/images/portfolio/gallery-19.jpg',
      title: 'Gallery Image 6'
    }
  ];

  openGallery(index: number): void {
    this.currentGalleryIndex = index;
    this.showGalleryModal = true;
  }

  closeGallery(): void {
    this.showGalleryModal = false;
  }

  nextGalleryImage(): void {
    if (this.currentGalleryIndex < this.galleryItems.length - 1) {
      this.currentGalleryIndex++;
    } else {
      this.currentGalleryIndex = 0;
    }
  }

  previousGalleryImage(): void {
    if (this.currentGalleryIndex > 0) {
      this.currentGalleryIndex--;
    } else {
      this.currentGalleryIndex = this.galleryItems.length - 1;
    }
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeGallery();
  }

  // Video Popup
	isOpen = false;
  openPopup(): void {
      this.isOpen = true;
  }
  closePopup(): void {
      this.isOpen = false;
  }

  // OWl Slider
  brandsCarousel: OwlOptions = {
    loop: true,
    dots: false,
    margin:50,
    nav:false,
    autoplay:true,
    autoplaySpeed: 2000,
    navSpeed: 2000,
    items: 6,
    navText: ['<i class="bi bi-arrow-left-short"></i>', '<i class="bi bi-arrow-right-short"></i>'],
  }

  brandStore = [
    {img: "brand-1-white.png"},
    {img: "brand-2-white.png"},
    {img: "brand-3-white.png"},
    {img: "brand-4-white.png"},
    {img: "brand-5-white.png"},
    {img: "brand-6-white.png"}
  ];

  // Contact Form
  formData = {
    user_name: '',
    user_email: '',
    message: ''
  };

  // EmailJS service configuration
  private serviceId = 'helifax-form';  // Replace with your EmailJS Service ID
  private templateId = 'helifax-form';  // Replace with your EmailJS Template ID
  private publicKey = 'dOfh1ImCGDZCO9GJb';  // Replace with your EmailJS Public Key

  // Method to send email on form submission
  public sendEmail(event: Event): void {
    event.preventDefault();

    // Send email using EmailJS
    emailjs.sendForm(this.serviceId, this.templateId, event.target as HTMLFormElement, this.publicKey)
      .then(
        (response: EmailJSResponseStatus) => {
          alert('Message sent successfully. Thank you, we will get back to you soon!');
          this.resetForm();
        },
        (error: EmailJSResponseStatus) => {
          console.error('Failed to send message. Error:', error.text);
          alert('Failed to send the message. Please try again later.');
        }
      );
  }

  // Method to reset the form after submission
  private resetForm(): void {
    this.formData = {
      user_name: '',
      user_email: '',
      message: ''
    };
  }
  // Contact Form End
}
